export default __webpack_public_path__ + "static/media/sproutz.0c496a6b.gif";